export enum MsalActionType {
    SetAuthResult = 'msal.SET_AUTH_RESULT',
    SetShowDialog = 'msal.SET_SHOW_MS_LOGIN_DIALOG',
}
